import React, { useEffect, useState } from "react"
import { Row, Label, Input } from "reactstrap"

const DBFileBrowser = ({
  rowClass,
  labelText,
  accept,
  showPrewiew,
  onsubmit,
  disable,
  value
}) => {
  const [filesAvailable, setFilesAvalable] = useState(false);
  const [fileSize, setFileSize] = useState(0);
  const [fileResolution, setFileResolution] = useState("");
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [size, setSize] = useState(0);


  useEffect(() => {
    if(value == null || value == undefined || value == ""){
      setFilesAvalable(false);
      setFileSize(0);
      setFileResolution("");
      setWidth(0);
      setHeight(0);
      setSize(0);
    }
  }, [value])


  const imageProperties = {
    width: 1050,
    height: 1050,
    size: 1024 * 1024
  }

  async function fileProperties(file) {
    const fileInput = file.target.files[0];
    if (!fileInput) {
      setFilesAvalable(false);
      setFileSize(0);
      setFileResolution("");
      return false;
    }


    const { width, height } = await getImageSize(fileInput);
    setFileResolution(`${width}(W) x ${height}(H)`);

    if (fileInput.size > imageProperties.size) {
      alert("File size is too large");
      return false;
    }

    if (width > imageProperties.width || height > imageProperties.height) {
      alert("Image dimensions are too large");
      return false;
    }

    setFileSize(parseFloat(fileInput.size / 1024 / 1024).toFixed(2));
    setFilesAvalable(true);

    return true;
  }

  function getImageSize(file) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const _URL = window.URL || window.webkitURL;
      const objectUrl = _URL.createObjectURL(file);

      img.onload = () => {
        const width = img.width;
        const height = img.height;
        _URL.revokeObjectURL(objectUrl);
        resolve({ width, height });
      };

      img.onerror = reject;

      img.src = objectUrl;
    });
  }


  return (
    <Row className={rowClass}>
      <div className="input-group" style={{ marginTop: '1px' }}>
        <Input
          type="file"
          disabled={disable}
          accept={accept}
          className="form-control"
          id="inputGroupFile04"
          aria-describedby="inputGroupFileAddon04"
          aria-label="Upload"
          size={'sm'}
          onChange={async (e) => {
            showPrewiew(e);
            const fileContent = e;
            var response = await fileProperties(fileContent)
          }}
          value={value}
        />
      </div>
      <div style={{ marginTop: "1px" }} hidden={!filesAvailable}>
        <div class="btn-group btn-group-sm" role="group" aria-label="File information" disable>
          <button type="button" hidden={!fileResolution} disabled class={`btn btn-secondary`}>Resolution | {fileResolution}</button>
          <button type="button" disabled class={`btn btn-secondary`}>Size | {fileSize} MB</button>
        </div>
      </div>
    </Row>
  )
}

export default DBFileBrowser
